import { SenecBaseTheme } from "src/styles/senecBaseTheme";
import { createTheme } from "@mui/material";

export const createTabComponentTheme = (theme: SenecBaseTheme) => {
    return createTheme({
        components: {
            /* Tab component overrides */
            MuiTabs: {
                styleOverrides: {
                    indicator: {
                        backgroundColor: theme.palette.senecPrimary.deepBlue,
                        borderRadius: "20px",
                        height: 2,
                    },
                    root: {
                        minHeight: "auto",
                    },
                },
            },
            MuiTab: {
                styleOverrides: {
                    root: {
                        color: "black",
                        "&.Mui-selected": {
                            color: theme.palette.senecPrimary.deepBlue,
                        },
                        minHeight: "auto",
                        minWidth: "auto",
                        marginRight: "1.5rem",
                        padding: "0.5rem 0.25rem",
                        // only apply right margin, if it is not the last tab
                        ":last-of-type": {
                            margin: 0,
                        },
                    },
                },
            },
        },
    });
};
